import { render, staticRenderFns } from "./IntegrationSettings.vue?vue&type=template&id=09b4aa2b"
import script from "./IntegrationSettings.vue?vue&type=script&lang=ts"
export * from "./IntegrationSettings.vue?vue&type=script&lang=ts"
import style0 from "./IntegrationSettings.vue?vue&type=style&index=0&id=09b4aa2b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports